<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 점검 정보 -->
<!--    <div class="mt-5 mb-6">-->
<!--      <p class="title my-4"><i class="dot"></i>점검정보</p>-->
<!--      <div class="grid grid-cols-12 gap-x-6 gap-y-4">-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">담당부서</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>-->
<!--          <company-selector-->
<!--            v-else-->
<!--            v-model="form.inputB_0"-->
<!--            @select="targetCompany"-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">점검자명</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->
<!--            placeholder=""-->
<!--            v-model="form.inputB_2"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">점검일</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>-->
<!--          <DateSelector-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->
<!--            placeholder="날짜선택"-->
<!--            v-model="form.inputB_3"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!--    점검항목-->
    <table-inspect-division-ep
      class="mt-2"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      title="안전보건 체크리스트"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import TableInspectDivisionEp from "@/components/TableInspectDivisionEp.vue";

export default {
  components: {
    TableInspectDivisionEp,
    CompanySelector,
    DateSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        inspectList: [],

        stdInfo: {},
        fileList: [],
        photoList: [],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.inputB_1 = value.com_name;
    },
    updateListCheck(indexTableRow, indexRows, text) {
      this.form.inspectList[indexTableRow].list[indexRows].is_checked = text;
    },
  },
  computed: {
    inspectTable () {
      return [
        {
          headerInput1Title: '점검사항',
          headerInput2Title: '관계법령',
          headerTitle: '점검항목',
          headerYesTitle: '실시',
          headerNoTitle: '미실시',
          headerNATitle: '해당없음',
          headerNoteTitle: '비고(보완계획)',
          isTypeMode : true,
          isInputMode: false,
          isInput1 : true,
          isInput2 : true,
          isInput3 : false,
          isNote : true,
          inputWidth1: '0.7fr',
          inputWidth2: '0.5fr',
          footer: '※ (중처법=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)',
          list: [
            {
              id: 1,
              type: '1',
              is_checked: '',
              input1: '도급인(발주자)의 산재예방조치\n' +
                '(건설공사1억 ~120억 미만)',
              input2: '산안법 제73조',
              label: '건설재해예방기술지도기관으로부터 기술지도\n' +
                '[월 2회 이상(15일마다 1회)]',
              noteCountList: [
                { label: '실시', value: '', unit: '개소' },
                { label: '미실시', value: '', unit: '개소' },
              ],
            },
            {
              id: 2,
              type: '2',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '산안법제64조, 제66조',
              label: '위생시설 이용 등 협조',
            },
            {
              id: 3,
              type: '3',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '산안법제64조, 제66조',
              label: '협의체 구성 및 운영 일지 작성(매월 1회)\n' +
                '도급인과 관계수급인의 산재예방조치 및 의견전달, 시정조치 등',
            },
            {
              id: 4,
              type: '4',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '산안법제64조, 제66조',
              label: '작업장 순회점검(주1회)',
            },
            {
              id: 5,
              type: '5',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '산안법제64조, 제66조',
              label: '합동 안전보건 점검(분기 1회 이상)',
            },
            {
              id: 6,
              type: '6',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '중처법 제4조',
              label: '안전보건관리체계의 구축 및 이행 조치\n' +
                '산업안전보건관리비 집행의 적정여부 감독, 위급시 작업의 중지와 대피에 대한 사항, 작업 혼재로 발생할 우려가 있는(화재, 폭발 등) 경우, 관계수급인 등의 작업시기·내용 위험기계 사용시 관리계획 등의 산재예방 조치 등의 여부',
            },
            {
              id: 7,
              type: '7',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '산안법 제64조',
              label: '안전보건교육을 위한 장소 및 자료의 제공 등 지원및 안전보건교육 실시 확인',
            },
            {
              id: 8,
              type: '8',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '산안법 시행령 제53조',
              label: '관계수급인의 위험성평가 실시 여부 확인',
              noteCountList: [
                { label: '실시', value: '', unit: '개소' },
                { label: '미실시', value: '', unit: '개소' },
              ],
            },
            {
              id: 9,
              type: '9',
              is_checked: '',
              input1: '도급·용역·위탁 등 산재예방  조치',
              input2: '산안법 제65조',
              label: '관계수급인이 안전보건에 관한 정보 요청 시 제공',
            },
          ]
        },
      ]
    },
  }
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
</style>
